import { UIStyledSection } from '../components/UIStyledSection';

export const UISectionBranding: React.FC = () => {
  return <UIStyledSection title="Branding">{`TODO <AppLogo />`}</UIStyledSection>;
};
